import { useLocation } from 'react-router-dom';

export function useSubmitRequestFlow() {
  const { pathname } = useLocation();
  return pathname.indexOf('/submit-request') !== -1;
}
